module.exports = __webpack_public_path__ + "img/VWALLMOUNT.c27d9e68.jpg";